import {gql} from '@apollo/client';

/**
 * Power-user-only mutation to delete a pending RTQ record (ON-9301).
 *
 * Gated server-side on the POWER_USER_EMAILS allow-list and on the record still
 * being pending — the FE gating in PowerUserDeleteAction is the first line of
 * defence, this mutation is the second (defence in depth).
 */
export const DELETE_PENDING_RTQ = gql`
  mutation DeletePendingRtq($atrId: UUID!) {
    deletePendingRtq(atrId: $atrId) {
      ok
      errors
    }
  }
`;
